import { supFixTwentyVsThirtyExp } from '../../experiments/frontDoorOffer';
import { useAllocation } from '../useAllocation';
import { mapAllocationToOffer } from './useFrontDoorOffer';
export const useSupFixOffer = (skip = false) => {
  const {
    data: allocationData,
    loading
  } = useAllocation(skip ? [] : [supFixTwentyVsThirtyExp]);
  const allocationValue = allocationData?.visitor?.configParams?.find(param => param.name === supFixTwentyVsThirtyExp.name)?.value;
  const offer = skip || loading ? null : mapAllocationToOffer(allocationValue);
  return {
    offer,
    slimBannerVariant: 'promo-dark',
    loading
  };
};